<form class="admin-filters" nz-form [formGroup]="searchForm" (ngSubmit)="submitFilterForm()">
  <div class="admin-filters__fields">
    <nz-form-item class="admin-filters__field">
      <nz-form-control>
        <nz-input-group [nzSuffix]="suffixIconSearch">
          <input
            type="text"
            formControlName="searchTerm"
            nz-input
            [placeholder]="'admin.filter.search.placeholder' | translate"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <span *ngIf="!searchForm.get('searchTerm')?.value" nz-icon nzType="search"></span>
          <span
            nz-icon
            class="ant-input-clear-icon"
            nzTheme="fill"
            nzType="close-circle"
            *ngIf="searchForm.get('searchTerm')?.value"
            (click)="searchForm.get('searchTerm')?.setValue(null)"
          ></span>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </div>
  <div class="admin-filters__actions">
    <nz-form-item>
      <nz-form-control>
        <button nz-button nzType="primary" [disabled]="!searchForm.valid">
          {{ "admin.filter.submit" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <button nz-button nzType="default" type="button" (click)="openCreateAdminModal()">
          {{ "admin.user-admin.create.open-modal" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
  </div>
</form>

<ng-template #rangeTemplate let-range="range" let-total>
  {{ range[0] }}-{{ range[1] }} of {{ total }} items
</ng-template>

<div class="desktop-only">
<nz-table
  class="sticky-table" [nzScroll]="{ x: '1200px' }"
  #basicTable
  [nzData]="tableState.data?.items || []"
  nzPaginationPosition="both"
  nzShowSizeChanger="true"
  nzSize="small"
  [nzShowTotal]="rangeTemplate"
  nzFrontPagination="false"
  [nzLoading]="tableState.loading"
  [nzTotal]="tableState.data?.paging?.items || 0"
  [nzPageSize]="tableState.data?.paging?.itemsOnPage || 0"
  [nzPageIndex]="tableState.data?.paging?.page || 0"
  (nzQueryParams)="onQueryParamsChange($event)"
>
  <thead>
    <tr>
      <th nzColumnKey="NAME" [nzSortFn]="true">{{ "admin.name.title" | translate }}</th>
      <th nzColumnKey="EMAIL" [nzSortFn]="true">{{ "admin.email.title" | translate }}</th>
      <th nzColumnKey="TYPE">{{ "admin.type.title" | translate }}</th>
      <th nzColumnKey="REG_TIMESTAMP" [nzSortFn]="true" nzSortOrder="descend">
        {{ "admin.registered.title" | translate }}
      </th>
      <th>{{ "admin.action.title" | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of basicTable.data">
      <td>{{ data.firstName }}</td>
      <td>{{ data.email }}</td>
      <td>{{ "admin.type." + data.type | translate }}</td>
      <td>{{ data.registrationTimestamp | date : "yyyy-MM-dd HH:mm:ss" }}</td>
      <td class="nowrap">
        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.password-reset-email.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="sendPasswordResetEmail(data.accountId, data.email)"
        >
          <span nz-icon nzType="send" nzTheme="outline"></span>
        </button>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="data.accountId.internalId"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="copyId(data.accountId.internalId)"
        >
          <span nz-icon nzType="info-circle" nzTheme="outline"></span>
        </button>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.set-password.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="openSetPasswordModal(data)"
        >
          <span nz-icon nzType="lock" nzTheme="outline"></span>
        </button>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.edit.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="openEditModal(data)"
        >
          <span nz-icon nzType="edit" nzTheme="outline"></span>
        </button>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.delete-account.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="showDeleteConfirm(data)"
        >
          <span nz-icon nzType="delete" nzTheme="outline"></span>
        </button>
      </td>
    </tr>
  </tbody>
</nz-table>
</div>

<div class="mobile-only" style="margin-top: 16px;">
  <nz-pagination
    *ngIf="!tableState.loading"
    [nzPageIndex]="tableState.data?.paging?.page || 1"
    [nzTotal]="tableState.data?.paging?.items || 0"
    [nzPageSize]="tableState.data?.paging?.itemsOnPage || 10"
    (nzPageIndexChange)="onPageChange($event)"
    nzSize="small"
    [nzShowTotal]="rangeTemplate"
    style="margin-bottom: 16px; text-align: center;"
  ></nz-pagination>

  <nz-spin [nzSpinning]="tableState.loading">
    <div style="display: flex; flex-direction: column; gap: 16px;">
      <nz-card *ngFor="let data of tableState.data?.items || []" nzHoverable nzSize="small">
        <nz-row [nzGutter]="[0, 8]">
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.name.title" | translate }}:</strong>
            <div>{{ data.firstName }}</div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>{{ "admin.email.title" | translate }}:</strong>
            <div>{{ data.email }}</div>
          </nz-col>
          <nz-col [nzSpan]="12">
            <strong>{{ "admin.type.title" | translate }}:</strong>
            <div>{{ "admin.type." + data.type | translate }}</div>
          </nz-col>
          <nz-col [nzSpan]="12">
            <strong>{{ "admin.registered.title" | translate }}:</strong>
            <div>{{ data.registrationTimestamp | date : "yyyy-MM-dd HH:mm:ss" }}</div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <nz-divider style="margin: 8px 0;"></nz-divider>
            <strong>{{ "admin.action.title" | translate }}:</strong>
            <div style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 8px;">
              <button nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.password-reset-email.tooltip' | translate" (click)="sendPasswordResetEmail(data.accountId, data.email)">
                <span nz-icon nzType="send" nzTheme="outline"></span>
                {{ "admin.password-reset-email.tooltip" | translate }}
              </button>
              <button nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="data.accountId.internalId" (click)="copyId(data.accountId.internalId)">
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
                Copy ID
              </button>
              <button nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.set-password.tooltip' | translate" (click)="openSetPasswordModal(data)">
                <span nz-icon nzType="lock" nzTheme="outline"></span>
                {{ "admin.set-password.tooltip" | translate }}
              </button>
              <button nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.edit.tooltip' | translate" (click)="openEditModal(data)">
                <span nz-icon nzType="edit" nzTheme="outline"></span>
                {{ "admin.edit.tooltip" | translate }}
              </button>
              <button nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.delete-account.tooltip' | translate" (click)="showDeleteConfirm(data)">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
                {{ "admin.delete-account.tooltip" | translate }}
              </button>
            </div>
          </nz-col>
        </nz-row>
      </nz-card>
    </div>
  </nz-spin>

  <nz-pagination
    *ngIf="!tableState.loading"
    [nzPageIndex]="tableState.data?.paging?.page || 1"
    [nzTotal]="tableState.data?.paging?.items || 0"
    [nzPageSize]="tableState.data?.paging?.itemsOnPage || 10"
    (nzPageIndexChange)="onPageChange($event)"
    nzSize="small"
    [nzShowTotal]="rangeTemplate"
    style="margin-top: 16px; text-align: center;"
  ></nz-pagination>
</div>
